module.exports = __webpack_public_path__ + "static/media/28.712d837d.png";